import { Fragment } from 'react'
import { StyledStep, StyledStepConnector, StyledStepLabel, StyledStepMarker, StyledSteps } from './styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

export interface Step {
  key: string
  label: string
  done: boolean
  current: boolean
}

interface OnboardingStepsProps {
  steps: Step[]
}

const OnboardingSteps = ({ steps }: OnboardingStepsProps) => {
  const isPulse = usePulseScope()

  return (
    <StyledSteps $pulse={isPulse}>
      {steps.map((step, index) => (
        <Fragment key={step.key}>
          {index > 0 && <StyledStepConnector $done={steps[index - 1].done} $pulse={isPulse} />}
          <StyledStep aria-current={step.current ? 'step' : undefined} $pulse={isPulse}>
            <StyledStepMarker $done={step.done} $current={step.current} $pulse={isPulse}>
              {step.done ? '✓' : index + 1}
            </StyledStepMarker>
            <StyledStepLabel $done={step.done} $current={step.current} $pulse={isPulse}>
              {step.label}
            </StyledStepLabel>
          </StyledStep>
        </Fragment>
      ))}
    </StyledSteps>
  )
}

export default OnboardingSteps
